import { Code, ConnectError, Interceptor } from "@connectrpc/connect";
import { getAuth } from "firebase/auth";

export const authInterceptor: Interceptor = (next) => async (req) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new ConnectError("Unauthorized", Code.Unauthenticated);
  }

  const token = await user.getIdToken();
  req.header.set("Authorization", `Bearer ${token}`);

  return await next(req);
};
